import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import DatePicker from 'material-ui/DatePicker';
import MenuItem from 'material-ui/MenuItem';
import Toggle from 'material-ui/Toggle';
import {Row, Col} from 'react-flexbox-grid/lib';

import styles from './styles/SearchFormStyles';
import globalStyles from 'layouts/material-admin/globalStyles';
import AccountSelector from 'containers/accountSelector/AccountSelector';

class SearchForm extends React.Component {

    menuItems(translate, selectedIdList, list) {
        return list.map(item => (
          <MenuItem
            key={item.id}
            insetChildren={true}
            checked={selectedIdList && selectedIdList.filter(x => x === item.value).length > 0}
            value={item.value}
            primaryText={translate(item.localizationKey)}
          />
        ));
    }


    selectFieldMenuItem(translate, selectedId, list) {
        return list.map(item => (
          <MenuItem
            key={item.id}
            insetChildren={true}
            checked={selectedId && selectedId === item.value}
            value={item.value}
            primaryText={translate(item.localizationKey)}
          />
        ));
    }

    render() {
        const {searchData, handleChange, handleListChange, handleMultipleSelectionChange,
            handleChangeDateFrom, handleChangeDateTo, handleToggle,
            translate, currentLanguage } = this.props;

        let DateTimeFormat = global.Intl.DateTimeFormat;

        const maxDate = new Date();
        return (
            <Row>
                <Col xs={12}>

                        <Row>
                            <Col md={4}>
                                <AccountSelector
                                    translate={translate}
                                    handleSelectedAccount={this.props.handleSelectedAccount}
                                    selectedAccount={searchData.selectedAccount} />
                            </Col>
                            <Col md={4}>
                                <SelectField
                                    floatingLabelText={translate('GLOBAL.eventClassification')}
                                    value={searchData.selectedClassificationValue}
                                    onChange={(event, index, value) => {handleListChange("selectedClassificationValue", value)}}
                                    name="selectedClassificationValue"
                                    fullWidth={true}>
                                    {this.selectFieldMenuItem(translate, searchData.selectedClassificationValue, searchData.eventClassificationList)}
                                </SelectField>
                            </Col>
                            <Col md={4}>
                                <SelectField
                                    floatingLabelText={translate('GLOBAL.crashSeverity')}
                                    value={searchData.selectedSeverityValues}
                                    onChange={(event, index, values) => {handleMultipleSelectionChange(event, index, values, "selectedSeverityValues")}}
                                    name="selectedSeverityValues"
                                    multiple={true}
                                    fullWidth={true}>
                                    {this.menuItems(translate, searchData.selectedSeverityValues, searchData.severityCodeList)}
                                </SelectField>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <TextField
                                    onChange={handleChange}
                                    name="icnId"
                                    type="number"
                                    value={searchData.icnId}
                                    hintText={translate('GLOBAL.icnId')}
                                    floatingLabelText={translate('GLOBAL.icnId')}
                                    fullWidth={true} />
                            </Col>
                            <Col md={4}>
                                    <Row>
                                        <Col md={6} >
                                            <SelectField
                                                floatingLabelText={translate('GLOBAL.deviceIdType')}
                                                name="selectedDeviceIdType"
                                                value={searchData.selectedDeviceIdType}
                                                onChange={(event, index, value) => {handleListChange("selectedDeviceIdType", value)}}
                                                fullWidth={true}>
                                                    <MenuItem key={0} value={"ESN"} primaryText={translate('GLOBAL.deviceESN')}/>
                                                    <MenuItem key={1} value={"Id"} primaryText={translate('GLOBAL.deviceId')}/>
                                                    <MenuItem key={2} value={"IMEI"} primaryText={translate('GLOBAL.deviceIMEI')}/>
                                            </SelectField>
                                        </Col>
                                        <Col md={6} >
                                            <TextField
                                                onChange={handleChange}
                                                name="deviceFilterValue"
                                                value={searchData.deviceFilterValue}
                                                hintText={translate('GLOBAL.device')}
                                                floatingLabelText={translate('GLOBAL.device')}
                                                fullWidth={true} />
                                        </Col>
                                    </Row>
                            </Col>
                            <Col md={4}>
                                <TextField
                                    onChange={handleChange}
                                    name="vin"
                                    value={searchData.vin}
                                    hintText={translate('GLOBAL.vin')}
                                    floatingLabelText={translate('GLOBAL.vin')}
                                    fullWidth={true} />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <DatePicker
                                    onChange={(event, date) => {handleChangeDateFrom(event, date, "dateFrom")}}
                                    name="dateFrom"
                                    DateTimeFormat={DateTimeFormat}
                                    locale={currentLanguage}
                                    cancelLabel={translate('GLOBAL.close')}
                                    maxDate={maxDate}
                                    value={searchData.dateFrom}
                                    hintText={translate('GLOBAL.dateFrom')}
                                    floatingLabelText={translate('GLOBAL.dateFrom')}
                                    fullWidth={true}/>
                            </Col>
                            <Col md={4}>
                                <DatePicker
                                    onChange={(event, date) => {handleChangeDateTo(event, date, "dateTo")}}
                                    name="dateTo"
                                    locale={currentLanguage}
                                    DateTimeFormat={DateTimeFormat}
                                    maxDate={maxDate}
                                    value={searchData.dateTo}
                                    hintText={translate('GLOBAL.dateTo')}
                                    floatingLabelText={translate('GLOBAL.dateTo')}
                                    fullWidth={true}/>
                            </Col>
                            <Col md={4}>
                                <div style={styles.toggleDiv}>
                                    <Toggle
                                        onToggle={(event) => {handleToggle("includeSubAccount")}}
                                        name="includeSubAccount"
                                        label={translate('SearchBox.searchInSubAccounts')}
                                        labelStyle={styles.toggleLabel}
                                        toggled={searchData.includeSubAccount}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <div style={globalStyles.clear} ></div>
                </Col>
            </Row>
        );
    }
}

SearchForm.propTypes = {
    handleChange: PropTypes.func.isRequired,
    handleListChange: PropTypes.func.isRequired,
    handleMultipleSelectionChange: PropTypes.func.isRequired,
    handleChangeDateFrom: PropTypes.func.isRequired,
    handleChangeDateTo: PropTypes.func.isRequired,
    searchData: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    currentLanguage: PropTypes.string.isRequired
}

export default SearchForm;


// WEBPACK FOOTER //
// ./src/components/search/SearchForm.js